module.exports = __webpack_public_path__ + "img-lock.png?6dbeefc67b02dc6873189945f5750f1c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/img-lock.png
// module id = 37
// module chunks = 0